/*
	Obbligatori:
		headerName
		field
	Facoltativi:
		width
*/

export default function SaitPercentageColumn(config) {
	return {
		headerName: config.headerName,
		width: config.width,
		field: config.field,
		hidden: config.hidden || false,
		flex: config.flex,
		columnType: "percentage",
		type: "number",
		renderCell: config.renderCell,
		valueFormatter: (value, row, column, apiRef) => {
			if (config.showZero) {
				return `${Math.round(value * 100) / 100 || 0} %`;
			} else {
				return value || value === 0 ? `${Math.round(value * 100) / 100} %` : value;
			}
		},
		objmod: config.objmod,
	};
}
